



























import { Component } from 'nuxt-property-decorator'
import base from '../common'
import DestinationsCategoryTree from '~/components/experience/destinations-category-tree/index.vue'
import SearchResultActivityList from '~/components/experience/search-result-activity-list/desktop/index.vue'
import NoneSearchResult from '~/components/experience/none-search-result/desktop/index.vue'
import SearchTravelServices from '~/components/experience/search-travel-services/index.vue'

@Component({
  components: {
    DestinationsCategoryTree,
    SearchResultActivityList,
    NoneSearchResult,
    SearchTravelServices
  }
})
export default class ExperienceSearchMainContent extends base {
}
